import { render, staticRenderFns } from "./InsertEvent.vue?vue&type=template&id=36f515ac&scoped=true"
import script from "./InsertEvent.vue?vue&type=script&lang=js"
export * from "./InsertEvent.vue?vue&type=script&lang=js"
import style0 from "./InsertEvent.vue?vue&type=style&index=0&id=36f515ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f515ac",
  null
  
)

export default component.exports